export default __webpack_public_path__ + "static/media/banner-bg-previdencia-incentivo-aporte.934af6fa.png";